import { ApiClient } from '@provider-portal/common/api';
import { combineEpics } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';

import { selectSelectedProvider } from 'rdx/account';
import { GlobalAppActions } from 'rdx/actions';
import { AppServices } from 'rdx/middleware';
import { requestPromotionsPermissionAsyncAction } from 'rdx/promotions/actions';
import { GlobalAppState } from 'rdx/state';

import {
  GetPromotionsPermissionsRequest,
  GetPromotionsPermissionsResponse,
} from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryCampaignProvider/apis';

const getPromotionsPermissions = (
  apiClient: ApiClient,
  request: GetPromotionsPermissionsRequest,
): Promise<GetPromotionsPermissionsResponse> => {
  return apiClient.deliveryCampaignProvider.getPromotionsPermissions(request);
};

const requestPromotionPermissionEpic = (
  action$: Observable<GlobalAppActions>,
  state$: Observable<GlobalAppState>,
  { apiClient }: AppServices,
): Observable<GlobalAppActions> => {
  return action$.pipe(
    filter(isActionOf(requestPromotionsPermissionAsyncAction.request)),
    withLatestFrom(state$),
    switchMap(([, state]) => {
      const selectedProvider = selectSelectedProvider(state);

      if (!selectedProvider || !selectedProvider.providerId) {
        return of(
          requestPromotionsPermissionAsyncAction.failure(new Error('Missed selected provider id')),
        );
      }

      return from(
        getPromotionsPermissions(apiClient, {
          provider_id: selectedProvider.providerId,
        }),
      ).pipe(
        map((response) => requestPromotionsPermissionAsyncAction.success(response)),
        catchError((err) => of(requestPromotionsPermissionAsyncAction.failure(err))),
      );
    }),
  );
};

export const promotionsPermissionsEpic = combineEpics(requestPromotionPermissionEpic);
